<script setup lang="ts">
import { ref } from 'vue'
import { type RouteLocationNormalizedLoaded } from 'vue-router'
import ProgressSplash from '@/components/Progress.vue'

defineProps<{ route: RouteLocationNormalizedLoaded }>()
const isLoading = ref(false)
const handleBeforeLeave = () => {
  isLoading.value = true
}
const handleAfterEnter = () => {
  isLoading.value = false
}
</script>
<template>
  <div class="transition-wrapper">
    <ProgressSplash :loading="isLoading" />
    <transition
      mode="out-in"
      :name="route.meta.transition || 'fade'"
      @before-leave="handleBeforeLeave"
      @after-enter="handleAfterEnter"
    >
      <slot></slot>
    </transition>
  </div>
</template>
: any: any_el_el
